import { RECEIVE_PRODUCT_ASSETS } from '../constants/actionTypes';

export function receiveProductAssets(payload) {
  return {
    type: RECEIVE_PRODUCT_ASSETS,
    payload,
  };
}
